import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=1f5beda3&scoped=true&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=1f5beda3&scoped=true&lang=css&"
import style1 from "./Chart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5beda3",
  null
  
)

export default component.exports